export default __webpack_public_path__ + "static/media/mylou-records.09832387.jpg";